module.exports = __webpack_public_path__ + "static/media/product5.cfda4f3c.webp";